<div class="w-full flex justify-center">
  <div class="flex flex-col max-w-[1400px] w-full">
    <zaeper-page-layout [pageLayout]="EPageLayout.CARDS"
                        [title]="'App Version bearbeiten'"
    >
      <zaeper-tab-navigation [tabs]="tabs">
        <ng-template zTemplate="tab">
          <zaeper-input-group [inputOptions]="localizedInfoInputGroup"/>
        </ng-template>

        <ng-template zTemplate="tab">
          einstellungen
        </ng-template>
      </zaeper-tab-navigation>
    </zaeper-page-layout>
  </div>
</div>
